import { PageHero } from "../components/site/PageHero";
import { ContactForm } from "../components/site/ContactForm";

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Request Service"
        title="Request your service."
        subtitle="Tell us what you need and the F&C Air Conditioning team will follow up with you."
      />
      <ContactForm />
    </>
  );
}
